import Vue from 'vue';
import VueMeta from 'vue-meta';
import i18n from '@/assets/lang';
import Filters from '@/assets/js/filters';
import App from './App';
import router from './router';

/*
 * Disable production tips when in production mode.
 * Vue production tips are tips and hints displayed in dev mode to remind the
 * developer of good practices for production, and warn him of potentiel caveats.
 */
Vue.config.productionTip = process.env.NODE_ENV !== 'production';

/*
 * Register Vue plugin to handle dynamic meta tags in html.
 */
Vue.use(VueMeta);

Vue.prototype.$store = {
  base: true,
};

/*
 * Register global filters to all Vue instances.
 * This codeblock is used to emulate vue pre-2.x filters.
 */
Filters.forEach(f => Vue.filter(f.name, f.filter));

/**
 * Export the main, global Vue instance containing the single-page application (SPA).
 *
 * @export
 * @public
 * @see vue
 * @type Vue
 */
/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js